module.exports = __webpack_public_path__ + "img/wheel_2x.a12762ff.png";